<template>
    <div  > 
        <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-image  src="/assets/authorize/loading.gif" ></el-image>  
        </el-dialog>
        
        <div style=" display:flex;line-height:35px;height:35px;font-weight:610;font-size:12px">
            <div style="display:flex">
                <div style="width:60px">物料编码:</div>
                <div style="width:140px">{{v_onerow['MATNO']}}</div>
            </div>
            <div style="display:flex">
                <div style="width:60px">物料名称:</div>
                <div style="width:340px">{{v_onerow['MATNM']}}</div>
            </div>
            <div style="display:flex">
                <div style="width:80px;color:green">当前采购日期:</div>
                <div style="width:80px">{{v_onerow['ORDDTTM']}}</div>
            </div>
        </div>
        <div style=" display:flex;line-height:35px;min-height:35px;font-weight:600;font-size:12px">
            <div style="display:flex">
                <div style="width:60px">物料类别:</div>
                <div style="width:140px">{{v_onerow['MATTYNM']}}</div>
            </div>
            <div style="display:flex">
                <div style="width:60px">规格描述:</div>
                <div style="width:500px">{{v_onerow['MATDESC']}}</div>
            </div>                
        </div>
        <div class="one-div" style="height:32px;margin-top:2px">
            <span class="oneRow">上一次采购订单信息</span> 
        </div>
        <div style=" display:flex;line-height:35px;height:35px;font-weight:600;font-size:12px">
            <div style="display:flex">
                <div style="width:100px">采购订单:</div>
                <div style="width:140px">{{v_poRow['IDNO']}}</div>
            </div>
            <div style="display:flex">
                <div style="width:100px">采购供应商:</div>
                <div style="width:420px">{{v_poRow['SUPNM']}}</div>
            </div>
        </div>
        <div style=" display:flex;line-height:35px;height:35px;font-weight:610;font-size:12px">
            <div style="display:flex">
                <div style="width:100px">货币:</div>
                <div style="width:140px">{{v_poRow['CRCYNM']}}</div>
            </div>                
            <div style="display:flex">
                <div style="width:100px;color:black">上一次采购日期:</div>
                <div style="width:160px">{{v_poRow['ORDDTTM']}}</div>
            </div> 
            <div style="display:flex">
                <div style="width:90px;color:black">税率%:</div>
                <div style="width:60px">{{v_poRow['TAX']}}</div>
            </div>        
        </div>
        <div style=" display:flex;line-height:35px;height:35px;font-weight:610;font-size:12px">
            <div style="display:flex">
                <div style="width:100px;color:green">当前采购单价:</div>
                <div style="width:140px">{{v_onerow['PRC']}}</div>
            </div>
            <div style="display:flex">
                <div style="width:100px;color:red">上一次采购单价:</div>
                <div style="width:160px">{{v_poRow['PRC']}}</div>
            </div>
            <div style="display:flex">
                <div style="width:90px;color:red">涨跌比例%:</div>
                <div style="width:60px">{{v_pct}}</div>
            </div>
        </div>
        <div class="one-div" style="height:32px;margin-top:2px">
            <span class="oneRow">历史采购订单信息【 最近半年 】</span> 
        </div>
        <el-table  :data="v_data" 
            border                            
            size="small"
            :row-class-name="tabRowClass"
            :row-key="getRowKey"
            :cell-style="{padding:'2px','font-size':'12px',color:'#808695'}"
            style="margin-top:-8px"
            :height="400" 
            show-summary
            :summary-method="getAverage"
            ref="refdtl"
            class="custom-table-border"
            cell-class-name="clearPadding"
            highlight-current-row > 
            <el-table-column label="序号" type="index" width="55"></el-table-column> 
            <el-table-column v-for="(item ) in prcCol.filter(item=>item.thide=='N' )" :key="item.key"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"                                  
                :min-width="item.width">
                <template slot="header"><span style="color:red" v-if="item.notnull=='Y'">{{item.title}}</span></template>
                <template  slot-scope="scope" >
                    <span  >{{scope.row[item.key]}}</span>
                </template>
            </el-table-column> 
        </el-table>
 
    </div>  
</template>
<script>
 
import { getTabColOrData,getBaseData } from '../../api/user';
import { getDate,getDate2} from '../../api/Select' 
//局部注册
export default {
    props: {
        v_row:{
            type: Object,
 
        } ,
    },
    data () {
        return {
            promtWin:false,
            prompt:'',
            custRow:{},
            v_poRow:{},
            active: 'first',
            supData:[],    
       
            idseq:'', //菜单主键
            v_onerow:{},
 
            tabData:[], //表数据
            v_data:[],
            tabArr:[], //表列
            prcCol:[],
  
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            dataCount:0,
            v_pct:'',
            loadWin:false,
 
        }
    },
    mounted () { 
 
 
    },
    computed: {
        editHeight: function() {
            return (window.innerHeight - 300) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 200) + 'px';
        }, 
    },
    components: {
     
    },
    created () {       
        //查询数据
        this.qryData()
        this.getTabField()
    },
    watch: {
 
    },
    methods: {
        //求平均值
        getAverage(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]='平均'
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if(column.property==='PRC' ){
                    const v_sum =values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ).toFixed(4)
                        }else{
                            return prev
                        }
                    },'')
                    if (data.length>0){
                        sums[index] = (Number(v_sum)/Number(data.length)).toFixed(4)
                    }else{
                        sums[index] =''
                    }
                }
            })
            return sums
        },
        qryData(){
            this.v_onerow =JSON.parse(JSON.stringify(this.v_row))
            this.v_data=[]
            this.v_poRow={}
            this.loadWin =true
            this.v_pct =''
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key:'corpid', p_value:this.v_corpid,p_key2:'matno',p_value2:this.v_row['MATNO'], p_table:'V_POORD_MATLIST',p_cond:' and adddttm<\''+this.v_row['ADDDTTM']+'\' order by adddttm desc'},
            }).then(res=>{ 
                if (res.result.length>0){
                    this.v_poRow=res.result[0]
                    let v_prc =this.v_onerow['PRC']
                    let v_bef =this.v_poRow['PRC']
                    if (v_prc && v_bef&& v_bef>0 ){
                        this.v_pct =((Number(v_prc)-Number(v_bef))/Number(v_bef) *100).toFixed(2)
                    }
                }
                this.v_data =res.result.filter(item=>item['ORDDTTM']>= getDate2(180))
                this.loadWin =false
                setTimeout(() => {
                    this.$refs['refdtl'].doLayout()
                }, 500);
            })
        },
        getRowKey(row){
            return row.index
        },
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
        }, 
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','108','lstseq','2630','thide','N',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.prcCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        notnull: res.result[k].NOTNULL,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
 
        }
    }
}
</script>
<style scoped lang="less">
    .el-aside {
        height: calc(100vh - 100px);// vh就是当前屏幕可见高度的1%   只用设置左侧 aside 高度
    }
    .oneMenu{
        line-height:35px;
        text-align:left;
        padding-left:35px;
        font-size:14px;
        color:white;
        background-color: #409eff;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#f4f6f8;
    }
    .twoMenu{
        display:flex;
        flex-direction:column;
        line-height:40px;
        background:white;
        padding-left:35px;
 
    }
    .twoMenu:hover{
        cursor: pointer;
        color:#409EFF;
    }
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }  
    .el-header  {
        background-color: #fff;
        color: #409EFF;
        text-align: center;
        line-height: 60px;
        width:100%;
    }
  .el-main {
    background-color: #fff;
    color: rgb(207, 206, 206);
    text-align: center;
    height:100%;
  }
 .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
    .active { 
        color:#D200D2; 
    } 
    .wraper{
        width:1250px;
        margin:1px auto;
    }
</style>
<style lang="less">
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    // .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
 